import React from 'react';
import { TrendingUp, ExternalLink, Eye } from 'lucide-react';
import { GameSummary } from '@/api/types';
import { useTrackClick } from '@/hooks';
import { buildImageUrl } from '@/utils/image-url';
import { calculateHeat } from '@/utils/heat-score';
import styles from './desktop-game-card.module.css';

interface DesktopGameCardProps {
  game: GameSummary;
}

export const DesktopGameCard: React.FC<DesktopGameCardProps> = ({ game }) => {
  const trackClick = useTrackClick();
  const heatScore = calculateHeat(game.viewCount, 0);

  const handleClick = () => {
    trackClick.mutate({ gameId: parseInt(game.id, 10) || 0, platformId: 'default' });
  };

  return (
    <a
      href={`/game/${game.id}`}
      className={styles.card}
      onClick={handleClick}
    >
      <div className={styles.cover}>
        <img
          src={buildImageUrl(game.cover)}
          alt={game.title}
          className={styles.image}
          loading="lazy"
          onError={(e) => {
            (e.target as HTMLImageElement).src = '/fallback-cover.png';
          }}
        />
        <div className={styles.overlay}>
          <div className={styles.heat}>
            <TrendingUp size={14} />
            <span>热度 {heatScore}</span>
          </div>
          <div className={styles.viewCount}>
            <Eye size={14} />
            <span>{game.viewCount.toLocaleString()}</span>
          </div>
        </div>
      </div>
      <div className={styles.info}>
        <div className={styles.header}>
          <h3 className={styles.name}>{game.title}</h3>
          <ExternalLink size={16} className={styles.linkIcon} />
        </div>
        <p className={styles.category}>{game.category}</p>
        <div className={styles.footer}>
          <div className={styles.platforms}>
            {game.platforms.slice(0, 3).map((platform) => (
              <span key={platform.id} className={styles.platform}>
                {platform.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </a>
  );
};

export default DesktopGameCard;
